import React from "react";

// Minimal table wrapper: columns = [{ key, label, align, render(row) }].
// Optional `footer` = { [columnKey]: node } renders a summary row (e.g. a
// "Total" line) under the body; columns without an entry render empty.
// Body cells carry `data-label` (the column label) so a table can reflow into
// stacked label/value rows on phones purely in CSS.
export default function TspTable({ columns, rows, rowKey = "id", footer, className = "", rowClassName }) {
  return (
    <div className="tsp-table-wrap">
      <table className={`tsp-table ${className}`}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} style={{ textAlign: col.align || "left" }}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row[rowKey]} className={rowClassName ? rowClassName(row, index) : undefined}>
              {columns.map((col) => (
                <td key={col.key} data-label={col.label} style={{ textAlign: col.align || "left" }}>
                  {col.render ? col.render(row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        {footer && (
          <tfoot>
            <tr>
              {columns.map((col) => (
                <td key={col.key} style={{ textAlign: col.align || "left" }}>
                  {footer[col.key]}
                </td>
              ))}
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
}
